<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="customer_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('customer')">
                            <customers-auto-complete v-model="form.customer_id"
                                                 :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                     <ValidationProvider name="period_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('period')">
                            <payment-periods-selectbox v-model="form.period_id"
                                                :validateError="errors[0]">
                            </payment-periods-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="amount" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('amount')">
                            <b-form-input
                                type="number"
                                min="0" step=".01"
                                v-check-min-max-value
                                v-model="form.amount"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="currency" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('currency')">
                            <currency-selectbox
                                :validate-error="errors[0]"
                                v-model="form.currency"
                            ></currency-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="date" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('refund_date')">
                            <select-date v-model="form.date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
						</b-form-group>
					</ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="reason" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('reason')">
                            <parameter-selectbox v-model="form.reason" :validate-error="errors[0]" code="refund_reasons"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="explanation" rules="" v-slot="{errors}">
                        <b-form-group :label="$t('explanation')">
                            <b-form-textarea v-model="form.explanation"
                                             :class="errors[0] ? 'is-invalid':''"
                                             rows="6" />
                            <span class="invalid-feedback-custom" v-show="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="col-12 mt-3 d-flex">
                <b-button @click="storeForm"
                          :disabled="formLoading"
                          type="button"
                          variant="primary"
                          class="btn-lg mr-2">
                    {{ $t('save').toLocaleUpperCase('tr-TR') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
	// Components
    import CustomersAutoComplete from "@/components/interactive-fields/CustomersAutoComplete.vue";
    import PaymentPeriodsSelectbox from "@/components/interactive-fields/PaymentPeriodsSelectbox";
    import CurrencySelectbox from "@/components/interactive-fields/CurrencySelectbox.vue";
    import SelectDate from "@/components/interactive-fields/SelectDate";
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';

	// Services
    import CustomerRefundService from "@/services/CustomerRefundService";

    // Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"


    export default {
        components: {
            ValidationProvider, 
            ValidationObserver,

            CustomersAutoComplete,
            PaymentPeriodsSelectbox,
            CurrencySelectbox,
            SelectDate,
            ParameterSelectbox,
        },
        data() {
            return {
                formLoading: false,
                form: {
                    customer_id: null,
                    period_id: null,
                    amount: null,
                    currency: null,
                    date: null,
                    reason: null,
                    explanation: null,
                }
            }
        },
        methods: {
            async storeForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    CustomerRefundService.store(this.form)
                                 .then((response) => {
                                     this.$toast.success(this.$t("api." + response.data.message));
                                     this.$emit("createFormSuccess")
                                 })
                                 .catch((error) => {
                                     this.showErrors(error, this.$refs.formModalValidate)
                                 });
                }
            }
        }
    }
</script>
